import React from 'react'
import { IPalette } from 'containers/dashboard/design/color-palette/store/types'
import './NewLoaderBackground.css'

interface NewLoaderBackgroundProps {
    palette?: IPalette
    children: React.ReactNode
}

const NewLoaderBackground: React.FC<NewLoaderBackgroundProps> = ({
    palette,
    children,
}) => {
    const backgroundStyle = {
        backgroundColor: palette?.background || '#EDEDED',
    }

    const backgroundImageStyle = {
        backgroundImage: palette?.originalBackgroundImage
            ? `url(${palette.originalBackgroundImage})`
            : 'none',
        filter:
            palette?.blur && palette?.originalBackgroundImage
                ? `blur(${(palette.blur / 100) * 10}px)`
                : 'none',
    }

    return (
        <div className='new-loader-background' style={backgroundStyle}>
            {palette?.originalBackgroundImage && (
                <div
                    className='new-loader-background-image'
                    style={backgroundImageStyle}
                />
            )}
            <div className='new-loader-background-content'>{children}</div>
        </div>
    )
}

export default NewLoaderBackground
